import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';

const PlanItemRow = styled.div`
  font-size: 16px;
  margin-bottom: 10px;
  line-height: 40px;
  display: flex;
`;

const Title = styled.div`
  white-space: nowrap;
  padding-right: 8px;
  font-weight: bold;
`;

const PlanItem = ({ title, value }: { title: string, value?: string }) => {
  const [v, setV] = useState<string>(value || '');

  useEffect(() => {
    setV(value || '');
  }, [value]);

  return (
    <PlanItemRow>
      <Title>{title}:</Title> 
      <input 
        type="text" 
        value={v} 
        onChange={e => setV(e.target.value)}
        style={{ 
          width: '100%',
          height: '35px',
          border: 'none',
          borderBottom: '1px solid gray',
          backgroundColor: 'transparent',
          fontSize: '16px' 
        }} 
      />
    </PlanItemRow>
  );
};

export default PlanItem;
